import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.onEscape = this.onEscape.bind(this)
  }

  toggleScrollLock(delta) {
    const body = document.body
    const docEl = document.documentElement
    let open = parseInt(body.dataset.openModals || "0", 10)
    open = Math.max(0, open + delta)
    body.dataset.openModals = String(open)
    if (open > 0) {
      body.classList.add("overflow-hidden")
      docEl.classList.add("overflow-hidden")
    } else {
      body.classList.remove("overflow-hidden")
      docEl.classList.remove("overflow-hidden")
    }
  }

  open(event) {
    if (event) event.preventDefault()
    this.dialogTarget.classList.remove("hidden")
    document.addEventListener("keydown", this.onEscape)
    this.toggleScrollLock(1)
  }

  close() {
    this.dialogTarget.classList.add("hidden")
    document.removeEventListener("keydown", this.onEscape)
    this.toggleScrollLock(-1)
  }

  onEscape(event) {
    if (event.key === "Escape") this.close()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  disconnect() {
    document.removeEventListener("keydown", this.onEscape)
    if (!this.dialogTarget.classList.contains("hidden")) {
      this.toggleScrollLock(-1)
    }
  }
}
